import { AutocompletePaperSlotPropsOverrides, Paper, PaperProps, Stack, styled, SvgIcon, Typography } from '@mui/material'
import isFunction from 'lodash/isFunction'
import { PlusOMIcon } from '@omnea-app/icons'

type AutocompleteAddNewPaperProps = {
  onAddNew: (() => void) | undefined
  addNewText: string | undefined
  /** Closes the popup before opening the add-new surface; omit when the autocomplete is uncontrolled. */
  setIsOpen?: (isOpen: boolean) => void
} & PaperProps &
  AutocompletePaperSlotPropsOverrides

/** Autocomplete dropdown paper with an "add new" footer below the options. Pass as the `paper` slot;
 * the footer only renders when both `onAddNew` and `addNewText` are set. */
export const AutocompleteAddNewPaper = ({ onAddNew, addNewText, setIsOpen, children, ...rest }: AutocompleteAddNewPaperProps) => {
  return (
    <Paper {...rest}>
      <Stack>{children}</Stack>
      {isFunction(onAddNew) && addNewText && (
        <Paper>
          <AddNewButton
            onMouseDown={(event) => {
              event.preventDefault()
              setIsOpen?.(false)
              onAddNew()
            }}
          >
            <SvgIcon
              component={PlusOMIcon}
              inheritViewBox
              sx={{ marginRight: (theme) => theme.spacing(2), color: 'fg.subtle', fontSize: '20px' }}
            />

            <Typography color="text.brand.default" variant="body-regular">
              {addNewText}
            </Typography>
          </AddNewButton>
        </Paper>
      )}
    </Paper>
  )
}

const AddNewButton = styled('button')(({ theme }) => ({
  height: '48px',
  backgroundColor: theme.palette.bg.surface.default,
  ':hover': {
    backgroundColor: theme.palette.bg.interactive.hover,
  },
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  padding: '12px 16px',
  width: '100%',
  border: 'none',
}))
